import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { FirebaseConfig, FirebaseVapidKey } from '../constants/app.constant';

// Helper function to check if the current environment is a custom webkit iOS
function isCustomWebkitIOS() {
  const userAgent = navigator.userAgent.toLowerCase();
  console.log(userAgent.includes('xdi-ios'));
  return true;
}

// Initialize Firebase only if not in custom webkit iOS
let firebaseApp = null;
let messaging = null;

if (!isCustomWebkitIOS()) {
  firebaseApp = initializeApp(FirebaseConfig);
  messaging = getMessaging(firebaseApp);
}

// Request permission and get FCM token
export const requestNotificationPermission = async () => {
  try {
    // Skip for custom webkit iOS
    if (isCustomWebkitIOS()) {
      console.log('Custom webkit iOS detected. Skipping notification permission request.');
      return null;
    }
    
    console.log('Requesting notification permission...');
    
    // Check if notification API is available
    if (!('Notification' in window)) {
      console.log('This browser does not support notifications');
      return null;
    }
    
    // Request permission
    const permission = await Notification.requestPermission();
    
    if (permission !== 'granted') {
      console.log('Notification permission denied');
      return null;
    }
    
    console.log('Notification permission granted');
    
    // Get FCM token using VAPID key from constants
    const vapidKey = FirebaseVapidKey;
    const token = await getToken(messaging, { vapidKey });
    
    if (token) {
      console.log('FCM Token:', token);
      return token;
    } else {
      console.log('No registration token available.');
      return null;
    }
  } catch (error) {
    console.error('Error requesting notification permission:', error);
    return null;
  }
};

// Handler for foreground messages
export const onMessageListener = () => {
  // Skip for custom webkit iOS
  if (isCustomWebkitIOS()) {
    return Promise.resolve(null);
  }
  
  return new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      console.log('Message received in foreground:', payload);
      resolve(payload);
    });
  });
};

export { messaging };
export default firebaseApp;
